import React from 'react'

import { connect } from 'react-redux'

import './index.css'

import { 
  Upload, 
  Icon, 
  Modal, 
  message,
  Input
} from 'antd';

import { 
  API_ENDPOINT
} from '../../../../index'

import {
  setFileList
} from '../../actions'

class AssetUploader extends React.Component {

  state = {
    previewVisible: false,
    previewImage: ''
  };

  render() {

    if( !this.props.activeCategoryFeature ){
      return (
        <div>loading...</div>
      )
    }

    const { 
      previewVisible, 
      previewImage, 
    } = this.state;

    const {
      fileList
    } = this.props.activeCategoryFeature

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <div className="clearfix">
        
        <Upload
          name="picture"
          withCredentials
          action={`${API_ENDPOINT}/api/upload/category-feature-assets`}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
        >
          {fileList.length > 8? null : uploadButton}
        </Upload>
        
        <Modal 
        centered
        visible={previewVisible} 
        footer={null} 
        onCancel={this.handleCancel}>
          <img alt="example" style={{ height: '100%', width: '100%' }} src={previewImage} />
        </Modal>

      </div>
    );
  }

  constructor(props){
    super(props)
    
  }

  handleCancel = () => {
    this.setState({ previewVisible: false })
  };

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  handleChange = ({fileList}) => {
    
    this.props.setFileList(
      fileList.map( _file => {

        if( _file.response ){
          _file.url = _file.response && _file.response.categoryFeatureImage && _file.response.categoryFeatureImage.url
        }

        return _file
      })
    )
  };
  
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
}


export default connect(
  state => ({
    loading: state.categoryFeatures.loading,
    activeCategoryFeature: state.categoryFeatures.activeCategoryFeature
  }),
  dispatchEvent => ({
    setFileList: (fileList) => dispatchEvent( setFileList( fileList ))
  })
)(AssetUploader)


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/asset-uploader/index.js